import type { MeetingInsights } from "../types/insights";
import { apiUrl } from "./base";

export async function generateMeetingInsights(input: {
  transcript: string;
  contactType: string;
}): Promise<MeetingInsights> {
  const res = await fetch(apiUrl("/api/meetingInsights"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  });

  if (!res.ok) {
    throw new Error(await res.text());
  }

  return (await res.json()) as MeetingInsights;
}

